<template>
  <div>
    <label for="chatbot-footer-input" class="chatbot-connect-search connect_search">
      <ul class="search-qa">
        <li
          v-for="(item, index) in questionList"
          v-html="item.html"
          :key="index"
          @click="askQuestion(item.text)"
        ></li>
        <li v-if="questionList.length > 0" @click="showContactDialog">
          没有你想要的问题？点我试试
        </li>
        <li v-else @click="showContactDialog">
          很抱歉，没有找到相关的问题，点我试试
        </li>
      </ul>
    </label>
  </div>
</template>

<script>
import { getMessageList } from "@/utils/index";

export default {
  name: "chatbotConnectSearch",
  data() {
    return {};
  },
  computed: {
    questionList() {
      // console.log("questionList = ", this.$store.state.questionList);
      return this.$store.getters.get_questionList;
    },
  },
  methods: {
    askQuestion(item) {
      // console.log("item", item);
      const that = this;
      getMessageList(item, that);
      this.$emit("clearInput");
    },
    showContactDialog() {
      this.$emit("showDialog");
    },
  },
};
</script>
<style lang="scss">
.connect_search {
  display: block;
}

.chatbot-connect-search {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0 0 30px -5px #e7e8ee;
  max-height: 150px !important;
  overflow: hidden;
  overflow-y: scroll;
  position: fixed; /*DIV悬浮(固定位置)*/
  bottom: 3rem;
  left: 10px;
  width: 95%;
  background-color: #fff;
  z-index: 999;
}

.search-qa {
  text-align: left;
  list-style: none;
}

.search-qa li {
  line-height: 35px;
}

.color {
  color: #757575;
}
</style>
